<template>
  <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="disabled"
          dark
          v-bind="attrs"
          v-on="on"
        >
        {{ title }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
        v-for="(item, index) in items"
          :key="index"
          @click="menuChanged(item.eventName, item.value)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

</template>

<script>

export default {
  name: 'MenuBtn',
  props: {
      items: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: 'Click here',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
  },
  data: () => ({
  }),
  methods: {
    menuChanged(eventName, eventValue) {
      this.$emit(eventName, eventValue);
    },
  },
};

</script>
